import { ReactComponent as CloudIcon } from 'img/icons/cloud-colored.svg';
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { IS_BLOCKED, IS_FROZEN, IS_ONPREMISE } from 'reactApp/appHelpers/configHelpers';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { goToRegisterPage } from 'reactApp/modules/ph/ph.helpers';
import { selectStatusPage } from 'reactApp/modules/router/router.selectors';
import { SelectionsSelectors } from 'reactApp/modules/selections/selections.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { isWelcomePromoShow } from 'reactApp/modules/welcome/welcome.selectors';
import styles from 'reactApp/ui/Header/Header.css';
import { Search } from 'reactApp/ui/Header/Search/Search';
import { Toolbar } from 'reactApp/ui/Toolbar/Toolbar';
import { EToolbarItemMod } from 'reactApp/ui/Toolbar/Toolbar.types';
import { ToolbarItem } from 'reactApp/ui/Toolbar/ToolbarItem/ToolbarItem';
import { storages } from 'server/constants/storages';

interface Props {
    isSearchExpanded: boolean;
    toggleSearch: (state: boolean) => void;
    storage: EStorageType;
    searchOnlyExpanded: boolean;
}

export const RightSide = memo(({ isSearchExpanded, toggleSearch, storage, searchOnlyExpanded }: Props) => {
    const { isAttaches, isStart } = getStorage(storage);
    const isSelectingMode = useSelector(SelectionsSelectors.isAnyIndexSelected);
    const isAnonymous = useSelector(UserSelectors.isAnonymous);
    const isPhone = useSelector(EnvironmentSelectors.isPhone);
    const isWelcomePromo = useSelector(isWelcomePromoShow);
    const isErrorPage = useSelector(selectStatusPage);

    const searchAvailable = Boolean(storages[storage]?.isSearchAvailable) && !IS_FROZEN && !IS_BLOCKED && !isErrorPage;
    const showRegisterUrl = isAnonymous && !isPhone && !IS_ONPREMISE && !isErrorPage;
    const showToolbar = (!isSearchExpanded || isSelectingMode) && !isStart && !isWelcomePromo && !isErrorPage;

    return (
        <div className={styles.rightSide}>
            {showToolbar && (
                <div className={styles.toolbar}>
                    <Toolbar />
                </div>
            )}
            {((!isSelectingMode && searchAvailable) || isStart) && (
                <Search
                    onlyExpanded={searchOnlyExpanded}
                    dropdownAvailable={!isAttaches}
                    toggleSearch={toggleSearch}
                    isExpanded={isSearchExpanded}
                    storage={storage}
                />
            )}
            {showRegisterUrl && (
                <ToolbarItem id="cloud" text="Завести Облако" icon={<CloudIcon />} onClick={goToRegisterPage} mod={EToolbarItemMod.blue} />
            )}
        </div>
    );
});

RightSide.displayName = 'RightSide';
